import classNames from "classnames/bind";
import Carousel from "common/blocks/Carousel";
import type { ResolvedReviews } from "resolvers/data/trustpilotResolver";

import Review from "./Review";
import styles from "./ReviewsSection.module.scss";
import Service from "./Service";

const cx = classNames.bind(styles);

export interface ResolvedReviewsSection {
    title: string;
    trustpilot: ResolvedReviews;
}

const ReviewsSection = ({ title, trustpilot }: ResolvedReviewsSection) => {
    return !!trustpilot.totalReviews ? (
        <section className={cx("section")}>
            <div className={cx("wrapper")}>
                <Carousel
                    id="reviewsSectionCarousel"
                    title={title}
                    spaceBetween={40}
                    className={cx("carousel")}
                    isCarouselSection
                >
                    {trustpilot.reviews.map((review, i) => (
                        <Review {...review} service="trustpilot" key={i} />
                    ))}
                </Carousel>
                <div className={cx("services")}>
                    <hr className={cx("line")} />
                    {trustpilot && (
                        <Service
                            rating={trustpilot.rating}
                            totalReviews={trustpilot.totalReviews}
                            className={cx("trustpilot")}
                            service="trustpilot"
                        />
                    )}
                </div>
            </div>
        </section>
    ) : null;
};

export default ReviewsSection;
